"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _link = _interopRequireDefault(require("../core/link"));
var _rowConfig = _interopRequireDefault(require("../core/row-config"));
var _formGroup = _interopRequireDefault(require("../core/form-group"));
var _label = _interopRequireDefault(require("../core/label"));
var _col = _interopRequireDefault(require("../core/col"));
var _input = _interopRequireDefault(require("../core/input"));
var _submit = _interopRequireDefault(require("../core/submit"));
var _alert = _interopRequireDefault(require("../core/alert"));
var _container = _interopRequireDefault(require("../core/container"));
var _clubSetup = _interopRequireDefault(require("./club-setup"));
var _updateClubSetup = _interopRequireDefault(require("./update-club-setup"));
var _navBarMain = _interopRequireDefault(require("../core/nav-bar-main"));
var _footerMain = _interopRequireDefault(require("../core/footer-main"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "success"
}, "Verified"), /*#__PURE__*/_react.default.createElement("p", null, "Thank you for providing us with your data, which has been verified by stripe."), /*#__PURE__*/_react.default.createElement("p", null, "The competition organiser can now set up the competitions for entry."));
var _ref2 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Thank you for providing us with your data, unfortunately Stripe have been unable to verify it.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Please check your details exactly match those shown on your documents and that the documents are clear and then submit.");
var _ref4 = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "info"
}, "Pending"), /*#__PURE__*/_react.default.createElement("p", null, "Thank you for providing us with your data, which has been sent to stripe for verification. This page will update once verification is complete."), /*#__PURE__*/_react.default.createElement("p", null, "The competition organisers can now set up the competitions for entry, but we may need more information from you in the future if verification fails."));
var _ref5 = /*#__PURE__*/_react.default.createElement(_navBarMain.default, null);
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Treasurer Password");
var _ref7 = /*#__PURE__*/_react.default.createElement(_footerMain.default, null);
class TreasurerSetup extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      error: null,
      loggedIn: false,
      loggingIn: false,
      treasurerPassword: '',
      hasStripeSetup: null,
      verificationStatus: null
    });
    _defineProperty(this, "_setTreasurerPassword", treasurerPassword => {
      this.setState({
        treasurerPassword
      });
    });
    _defineProperty(this, "_onLogin", e => {
      e.preventDefault();
      this._verifyPassword().then();
    });
    _defineProperty(this, "_verifyPassword", () => {
      return this.props.onVerifyPassword({
        id: this.props.club.id,
        treasurerPassword: this.state.treasurerPassword
      }).then(result => {
        if (result.success) {
          this.setState({
            loggedIn: true,
            hasStripeSetup: result.hasStripeSetup,
            verificationStatus: result.verificationStatus
          });
        } else {
          this.setState({
            loggingIn: false,
            error: result.error
          });
        }
      }, () => {
        this.setState({
          loggingIn: false,
          error: 'There was an error verifying your password.'
        });
      });
    });
    _defineProperty(this, "_onSetup", data => {
      return this.props.onSetup({
        ...data,
        id: this.props.club.id,
        treasurerPassword: this.state.treasurerPassword
      }).then(result => {
        if (result.success) {
          return this._verifyPassword().then(() => result);
        }
        return result;
      });
    });
    _defineProperty(this, "_onUpdateSetup", data => {
      return this.props.onUpdateSetup({
        ...data,
        id: this.props.club.id,
        treasurerPassword: this.state.treasurerPassword
      }).then(result => {
        if (result.success) {
          return this._verifyPassword().then(() => result);
        }
        return result;
      });
    });
  }
  render() {
    const verificationStatus = this.state.verificationStatus;
    const stripeVerified = _ref;
    const failedStripeVerification = !verificationStatus ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "warning"
    }, "Not Verified ", verificationStatus.details), verificationStatus.newTreasurer ? null : _ref2, _ref3, /*#__PURE__*/_react.default.createElement(_updateClubSetup.default, {
      currentDetails: {
        address: verificationStatus.address,
        dob: verificationStatus.dob,
        firstName: verificationStatus.firstName,
        lastName: verificationStatus.lastName
      },
      onSetup: this._onUpdateSetup
    }));
    const stripeVerificationPending = _ref4;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref5, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: 100
      }
    }, /*#__PURE__*/_react.default.createElement(_container.default, null, /*#__PURE__*/_react.default.createElement("h1", null, "Club Account Setup - ", this.props.club.clubName), this.state.loggedIn ? !this.state.hasStripeSetup ? /*#__PURE__*/_react.default.createElement(_clubSetup.default, {
      onSetup: this._onSetup
    }) : verificationStatus && verificationStatus.status === 'verified' ? stripeVerified :
    // Check details field as initially everything comes back unverified
    // Checking details avoids giving a short lived false negative.
    // Also
    verificationStatus && verificationStatus.status === 'unverified' && (verificationStatus.details || verificationStatus.detailsCode) ? failedStripeVerification : stripeVerificationPending : /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onLogin
    }, !this.state.error ? null : /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.error), /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 2
      }, {
        sm: 8,
        md: 10
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "password",
      name: "treasurerPassword",
      value: this.state.treasurerPassword,
      onChange: this._setTreasurerPassword,
      required: true
    })))), /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.loggingIn
    }, "Sign In")), _ref7)));
  }
}
var _ref8 = {
  id: true,
  clubName: true
};
var _default = exports.default = (0, _reactBicycle.connect)(TreasurerSetup, props => ({
  ["club(id:" + JSON.stringify(+props.match.params.clubID) + ")"]: _ref8
}), (client, props) => ({
  onSetup(data) {
    return client.update('Club.setupStripe', data);
  },
  onUpdateSetup(data) {
    return client.update('Club.updateStripe', data);
  },
  onVerifyPassword({
    id,
    treasurerPassword
  }) {
    return client.update('Club.verifyTreasurerPassword', {
      id,
      treasurerPassword
    });
  }
}));